/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TemplateJobRerunRequest extends models.TemplateExecutionRequestBase {
    getFixupPrototypeFunction() { return TemplateJobRerunRequest.fixupPrototype; }

    static newInstance(model: Partial<TemplateJobRerunRequest>): TemplateJobRerunRequest {
        let obj = Object.assign(new TemplateJobRerunRequest(), model);
        TemplateJobRerunRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TemplateJobRerunRequest>): TemplateJobRerunRequest {
        if (!model) return null;
        return TemplateJobRerunRequest.newInstance(<TemplateJobRerunRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TemplateJobRerunRequest) {
        if (!obj) return;

        models.TemplateJobRerunRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TemplateJobRerunRequest): boolean {
        if (models.TemplateExecutionRequestBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, TemplateJobRerunRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
